import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getParentEdgeTypeId, getSimpleBranchingQuery } from '@iotv/datamodel-core';
import { Alert, CircularProgress, Stack } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { ConsumerDao } from '../../data/ConsumerDAO';
import { extractViewObjectFromNodeEdgeMapper } from '../../data/daoFunctions/nodeEdgeMapperTransform';
import { AdjacentType, ObjectViewType } from '../../types';
import { Listerlizer } from '../factories/Listerlizer/Listerlizer';
import { PartnerViewDefinition } from './viewDefinitions';
const debug = process.env.REACT_APP_DEBUG && false;
export const PartnerList = (props) => {
    /** Get partner group (named apex item) */
    const [partnerGroup, setPartnerGroup] = useState(undefined);
    useEffect(() => {
        ConsumerDao.getApexGroupsOfSupportedType('Partner').then(({ err, data }) => {
            if (err)
                return console.error('PartnerList', err);
            if (!data)
                return console.warn('PartnerList', 'no data on partner list res?');
            const apexPartnerGroup = data.find((g) => g.name === 'Apex Partners');
            if (!apexPartnerGroup) {
                setPartnerGroup(null);
                return;
            }
            setPartnerGroup(apexPartnerGroup);
            props.userFunctions.addObjectsToState([apexPartnerGroup]);
            const b = getSimpleBranchingQuery('Group', 'Partner', AdjacentType.CHILD);
            ConsumerDao.getGraphQueryRequestV2({ contextObjects: [apexPartnerGroup], query: b }).then((p_res) => {
                debug && console.log('Partner res', p_res);
            });
        });
    }, []);
    const partnerViewDefinition = PartnerViewDefinition;
    const viewDefinition = PartnerViewDefinition;
    const maxCols = 10;
    const viewDefinitionColumnVisibility = Object.fromEntries(Object.keys(viewDefinition ?? {})
        .slice(maxCols)
        .map((k) => [k, false]));
    const columnVisibilityReferences = {
        dataTableReference: 'CustomerGroupView',
        objectTypeId: 'Partner',
        viewType: ObjectViewType.List,
        externalColumnVisibility: viewDefinitionColumnVisibility,
    };
    const viewObject = useMemo(() => {
        if (!partnerGroup)
            return null;
        const v = extractViewObjectFromNodeEdgeMapper(props.applicationData, partnerGroup);
        debug && console.log('extracting view obj', v);
        return v;
    }, [partnerGroup, props.applicationData]);
    return (_jsxs(Stack, { children: [partnerGroup === undefined && _jsx(CircularProgress, {}), partnerGroup === null && (_jsx(Alert, { severity: "warning", children: "Please ensure the base partner group \"Apex Partners\" has been loaded and the Consumer Data API is up to date." })), partnerGroup && viewObject && (_jsx(Listerlizer, { userFunctions: props.userFunctions,
                transactionFunctions: props.transactionFunctions,
                viewObject,
                //initMode: ComponentMode.EDIT,
                autoQuery: true,
                contextObject: partnerGroup,
                adjacentFilter: {
                    objectType: 'Partner',
                    edgeFilter: { edgeTypeId: getParentEdgeTypeId('Partner', 'Group') },
                    adjacentType: AdjacentType.CHILD,
                },
                linkableItemsBranchingQueryDefinition: getSimpleBranchingQuery('Group', 'Partner', AdjacentType.CHILD),
                linkableItemsResultFilter: { objectTypeId: 'Partner' },
                viewDefinition: viewDefinition,
                columnVisibilityReferences: columnVisibilityReferences,
                searchRootObject: partnerGroup,
                newObjectViewDefinition: partnerViewDefinition,
                applicationData: props.applicationData }))] }));
};
